/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Theme, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from '../../lib/formik/Formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import MFCheckbox from '../../lib/formik/Checkbox';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkForCorrespondenceAddress,
  getApplicantName,
  getNomineeRelation,
  getUniqueIdentityText,
  isMinor,
  isModuleAllowed,
  isOnboardingTypeMinor,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
// import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, idProofLabelsMasters, IdProofsMasters, NOMINEE_OPT_OUT_DISCLAIMER, NOMINEE_OPT_OUT_FEATURE_ENABLED, NomineeRelations, USER_ROLES } from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { DeleteIconFilled } from '../../assets/SvgIcons';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import dayjs from '../../utils/dayjs';
import { showError } from '../../redux-store/actions/auth';
import { initiateNomineeModification, initiateNomineeModificationRes } from '../../redux-store/actions/nominee';
import NomineeOptOutDeclPopup from './NomineeOptOutDeclPopup';

type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  nomineesSOA: boolean;
  saveType: string;
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  // nomineePan: '',
  nomineeGuardianPan: '',
  isActive: true,
  Relationship: '',
  sno: 0,
  //added according to new requirements
  idProofType: '',
  idProofValue: '',
  mobile: '',
  email: '',
  address1: '',
  address2: '',
  address3: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  nomineesSOA: false,
  saveType: 'save and proceed',
};

const Nominee = ({
  nomineeName,
  index,
  values,
  mdmsCountriesList,
  nomineeTitle
}: {
  nomineeName: number;
  index: number;
  values: Values;
  mdmsCountriesList: mdmsCountriesList[];
  nomineeTitle: string;
}): JSX.Element => {
  const { dateOfBirth = '', nomineeGuardianPan = '', address1, address2, address3, city, state, pincode, country } = values.nominees[index];
  const anyAddressFilled = !!(address1 || address2 || address3 || city || state || pincode || country);
  const { setFieldValue, setValues } = useFormikContext();
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);

  const primaryApplicant = (application?.applicants ?? []).find(obj => obj.applicant_type === "1")
  const correspondenceAddressObj = (primaryApplicant?.addresses ?? []).find(obj => obj.address_type === "correspondence")
  const overseasAddressObj = (primaryApplicant?.addresses ?? []).find(obj => obj.address_type === "overseas")
  const permanentAddressObj = (primaryApplicant?.addresses ?? []).find(obj => obj.address_type === "permanent")

  // const [nomineeTitle, setNomineeTitle] = useState<string>('');
  // const { nominees } = values
  // const nomineeActiveLength = nominees.filter(nominee => nominee.isActive).length;

  // useEffect(() => {
  //   setNomineeTitle(getApplicantName(index + 1, true));
  // }, [nomineeActiveLength]);

  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineeName`}
          label={`Enter Nominee Name ${nomineeName}*`}
          placeholder={`Enter Nominee Name ${nomineeName}`}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Select Nominee Relationship*"
          items={NomineeRelations.filter((relation) => {
            const { nominees } = values;
            const selectedRelations = nominees
              .filter(
                (nominee, ind) =>
                  ind !== index &&
                  nominee.Relationship &&
                  nominee.isActive &&
                  ['MOTHER', 'FATHER', 'SPOUSE'].includes(nominee.Relationship)
              )
              .map((nominee) => nominee.Relationship);
            return !selectedRelations.includes(relation);
          }).map((relation) => ({
            key: relation,
            value: relation,
          }))}
          isCapitalize
        />
      </Grid>
      {values.nominees.map((nominee, idx: number) => {
        if (nominee.Relationship === 'OTHERS' && idx === index) {
          return (
            <Grid item xs={12} lg={6} key={idx}>
              <MFTextField
                name={`nominees.${index}.nomineeRelationship`}
                label="Please Specify Relationship*"
                placeholder={`Enter Nominee Relationship`}
              />
            </Grid>
          );
        }
      })}
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          label={'Date of Birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of Birth'}
          name={`nominees.${index}.dateOfBirth`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
          onKeyDown={preventSpecialCharacters}
        />
      </Grid>
      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePan`}
          label={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          placeholder={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          inputProps={{ style: { textTransform: 'uppercase' } }}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
          }}
        />
      </Grid> */}
      {isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.guardianName`}
              label={nomineeGuardianPan ? "Enter Guardian Name*" : "Enter Guardian Name"}
              placeholder="Enter Guardian Name"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.nomineeGuardianPan`}
              label={`Enter Guardian ${getUniqueIdentityText(company)?.pan}`}
              placeholder="Enter Guardian Pan"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineeGuardianPan`, e.target.value.toUpperCase());
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <SubHeading
          sx={{
            letterSpacing: '0.02px',
            variant: "h3",
          }}>
          Address & Contact Details of {nomineeTitle} Nominee
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mt: 1,
              flexWrap: 'wrap',
            }}
          >
            <Button
              variant="outlined"
              startIcon={<ContentCopyIcon sx={{ fontSize: '16px' }} />}
              sx={(theme: Theme) => ({
                ...theme.typography.subtitle_500,
                borderColor: theme.palette.primary[700],
                color: theme.palette.primary[500],
                backgroundColor: `${theme.palette.primary[500]}1A`,
                padding: '6px 16px',
                textAlign: 'left',
              })}
              onClick={() => {
                setValues({
                  ...values,
                  nominees: (values.nominees ?? []).map((obj) => {
                    if (obj.sno === index) {
                      if (checkForCorrespondenceAddress(
                        primaryApplicant?.applicantStatus ?? ''
                      )) {
                        return {
                          ...obj,
                          address1: correspondenceAddressObj?.address1 ?? "",
                          address2: correspondenceAddressObj?.address2 ?? "",
                          address3: correspondenceAddressObj?.address3 ?? "",
                          pincode: correspondenceAddressObj?.pincode ?? "",
                          city: correspondenceAddressObj?.city ?? "",
                          state: correspondenceAddressObj?.state ?? "",
                          country: correspondenceAddressObj?.country ?? "",
                        }
                      } else {
                        return {
                          ...obj,
                          address1: overseasAddressObj?.address1 ?? "",
                          address2: overseasAddressObj?.address2 ?? "",
                          address3: overseasAddressObj?.address3 ?? "",
                          pincode: overseasAddressObj?.pincode ?? "",
                          city: overseasAddressObj?.city ?? "",
                          state: overseasAddressObj?.state ?? "",
                          country: overseasAddressObj?.country ?? "",
                        }
                      }
                    }

                    return obj
                  })
                })
              }}
            >
              Same as Investor {checkForCorrespondenceAddress(
                primaryApplicant?.applicantStatus ?? ''
              ) ? "Correspondence address" : "Overseas Address"}
            </Button>
            <Button
              variant="outlined"
              startIcon={<ContentCopyIcon sx={{ fontSize: '16px' }} />}
              sx={(theme: Theme) => ({
                ...theme.typography.subtitle_500,
                borderColor: theme.palette.primary[700],
                color: theme.palette.primary[500],
                backgroundColor: `${theme.palette.primary[500]}1A`,
                padding: '6px 16px',
                textAlign: 'left',
              })}
              onClick={() => {
                setValues({
                  ...values,
                  nominees: (values.nominees ?? []).map((obj, objIndex) => {
                    if (obj.sno === index) {
                      return {
                        ...obj,
                        address1: permanentAddressObj?.address1 ?? "",
                        address2: permanentAddressObj?.address2 ?? "",
                        address3: permanentAddressObj?.address3 ?? "",
                        pincode: permanentAddressObj?.pincode ?? "",
                        city: permanentAddressObj?.city ?? "",
                        state: permanentAddressObj?.state ?? "",
                        country: permanentAddressObj?.country ?? "",
                      }
                    }

                    return obj
                  })
                })
              }}
            >
              Same as Investor Permanent address
            </Button>
          </Box>
        </SubHeading>
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.idProofType`}
          label={`Any one of the id proof`}
          items={IdProofsMasters.map(proof => ({ key: proof, value: proof }))}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.idProofType`, e.target.value);
            setFieldValue(`nominees.${index}.idProofValue`, '');
          }}
          {...(values.nominees[index].idProofType
            ? {
              // Show a clear (×) button inside the select when a value is selected;
              // shift it left so it doesn't overlap the dropdown arrow.
              endAdornment: (
                <IconButton
                  size="small"
                  aria-label="Clear ID proof type"
                  onClick={() => {
                    setFieldValue(`nominees.${index}.idProofType`, '');
                    setFieldValue(`nominees.${index}.idProofValue`, '');
                  }}
                  sx={{ mr: 2 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }
            : {})}
        />
      </Grid>
      {values.nominees[index].idProofType && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`nominees.${index}.idProofValue`}
            label={`${idProofLabelsMasters[values.nominees[index].idProofType as string]}*`}
            placeholder={idProofLabelsMasters[values.nominees[index].idProofType as string]}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            onChange={(e) => {
              setFieldValue(`nominees.${index}.idProofValue`, e.target.value.toUpperCase());
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.mobile`}
          label={`Mobile Number`}
          placeholder="Enter Mobile Number"
          onKeyDown={(e) => {
            preventSpecialCharacters(e);
          }}
          startAdornment={
            <CountryCodesDropDown
              name={`nominees.${index}.countryNameAndCode`}
              value={values.nominees[index].countryNameAndCode}
            />
          }
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.email`}
          label={`Email`}
          placeholder="Email"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address1`}
          label={`Address Line 1${anyAddressFilled ? '*' : ''}`}
          placeholder="Address Line 1"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address2`}
          label={`Address Line 2`}
          placeholder="Address Line 2"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address3`}
          label={`Address Line 3`}
          placeholder="Address Line 3"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.pincode`}
          label={`PIN Code${anyAddressFilled ? '*' : ''}`}
          placeholder="PIN Code"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.city`}
          label={`City${anyAddressFilled ? '*' : ''}`}
          placeholder="City"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.state`}
          label={`State${anyAddressFilled ? '*' : ''}`}
          placeholder="State"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <SearchableSelect
          name={`nominees.${index}.country`}
          label={`Country${anyAddressFilled ? '*' : ''}`}
          items={mdmsCountriesList.map((nationality) => ({
            key: nationality.name,
            value: nationality.name,
          }))}
          searchFieldPlaceholder={'Search Country'}
        />
      </Grid>
    </>
  );
};

export default function NomineeDetails({ isDirect = false, applicationId = '' }: { isDirect?: boolean; applicationId?: string; }): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  // const [nomineesToDelete, setNomineesToDelete] = useState<
  //   | {
  //       nominee: Partial<NomineeType>;
  //       // index: number;
  //     }[]
  //   | null
  // >(null);
  const [bulkNomineeDelete, setBulkNomineeDelete] = useState<boolean>(false);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [nomineeOptOutDeclPopupOpen, setNomineeOptOutDeclPopupOpen] = useState<boolean>(false)

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);


  const onSubmit = async (values: Values) => {
    try {
      if (isDirect) {
        const {
          nominees: existingNominees = [],
          id: applicationId,
          clientCode
        } = application || {};
        const { nominees, doNotWishToNominate } = values;

        const updatedPayload = {
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  applicationId,
                  nomineeRelationship: getNomineeRelation(Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    // : new Date(nominee.dateOfBirth).toISOString(),
                    : dayjs(nominee.dateOfBirth).format("YYYY-MM-DD"),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  countryCode: `${rest?.countryNameAndCode ?? ""}`?.split(':')[1].trim(),
                };
              }
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                nomineeRelationship: getNomineeRelation(Relationship)
                  ? Relationship
                  : removeSingleQuote(rest1.nomineeRelationship),
                dateOfBirth: !rest1.dateOfBirth ? null : dayjs(rest1.dateOfBirth).format("YYYY-MM-DD"),
                nomineeName: removeSingleQuote(rest1.nomineeName),
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                applicationId,
                countryCode: `${rest1?.countryNameAndCode ?? ""}`?.split(':')[1].trim(),
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? false : values?.nomineesSOA ?? false,
          clientCode: clientCode ?? '',
        };

        try {
          setLoading(true);
          const res = await (dispatch(initiateNomineeModification(updatedPayload))) as unknown as initiateNomineeModificationRes;
          if (!res) {
            return
          };
          if (res?.isSuccess) {
            history.push(`/nominee/otp-screen`, {
              id: res?.id ?? "",
              cartId: res?.cartId ?? "",
              message: res?.message ?? "",
              token: res?.token ?? "",
            });
          }
        } catch (e) {
          dispatch(showError("Please Try Again"))
        } finally {
          setLoading(false);

        }
      } else {
        const {
          nominees: existingNominees = [],
          id,
          applicant1ReferenceId = '',
          currentStep,
          status,
          hasPOA,
          applicationNumber,
        } = application || {};
        const { nominees, doNotWishToNominate, saveType } = values;
        const updatedPayload = {
          ...application,
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  nomineeRelationship: getNomineeRelation(Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    // : new Date(nominee.dateOfBirth).toISOString(),
                    : dayjs(nominee.dateOfBirth).format("YYYY-MM-DD"),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  countryCode: `${rest?.countryNameAndCode ?? ""}`?.split(':')[1].trim(),
                };
              }
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                nomineeRelationship: removeSingleQuote(rest1.nomineeRelationship),
                dateOfBirth: !rest1.dateOfBirth ? null : dayjs(rest1.dateOfBirth).format("YYYY-MM-DD"),
                nomineeName: removeSingleQuote(rest1.nomineeName),
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                countryCode: `${rest1?.countryNameAndCode ?? ""}`?.split(':')[1].trim(),
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? false : values?.nomineesSOA ?? false,
        };
        const checkApplication = applicationComparison(
          {
            ...application,
            nominees: application?.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
          },
          {
            ...updatedPayload,
            nominees: updatedPayload.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
            currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
          }
        );
        const isSaveLater = saveType !== 'save and proceed';

        let currentStatus = status

        if (
          !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
          status === 'sent_to_amc_approver'
        ) {
          currentStatus = 'draft'
        } else if (
          !hasPOA &&
          AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
          status !== 'draft' &&
          applyRoleBasedStatus(role)
        ) {
          currentStatus = 'sent_to_amc_approver'
        }

        if (id && !checkApplication) {
          setLoading(true);
          const response = await dispatch(
            updateApplication({
              body: {
                ...updatedPayload,
                status: currentStatus,
                currentStep: 6,
                //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
              },
              applicationId: id,
              ...(isSaveLater && { toastMessage: '' }),
            })
          );
          if (!response) return;
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        } else if (checkApplication) {
          if (isSaveLater) {
            enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          }
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        }
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { nominees = [], doNotWishToNominate = true, onboardingType = '', nomineesSOA } = application || {};
    setNomineesData({
      ...nomineesData,
      doNotWishToNominate: isOnboardingTypeMinor(onboardingType)
        ? true
        : nominees.length
          ? false
          : doNotWishToNominate === null
            ? true
            : doNotWishToNominate,
      nominees: nominees.length
        ? nominees.map((nominee, index) => ({
          ...nominee,
          Relationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
            ? nominee.nomineeRelationship
              ? nominee.nomineeRelationship.toUpperCase()
              : nominee.nomineeRelationship
            : 'OTHERS',
          nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
            ? ''
            : nominee.nomineeRelationship,
          sno: index,
          nomineePercentage: nominee.nomineePercentage
            ? nominee.nomineePercentage
            : nominees.length === 1
              ? 100
              : 0,
          countryNameAndCode: nominee.countryNameAndCode
            ? nominee.countryNameAndCode
            : 'India: +91',
          countryCode: nominee.countryCode ? nominee.countryCode : '+91',
        }))
        : [],
      nomineesSOA: doNotWishToNominate ? false : nomineesSOA ?? false
    });
  }, [application]);

  const handleNomineeOptOutDeclPopupOpen = () => {
    setNomineeOptOutDeclPopupOpen(true)
  }

  const handleNomineeOptOutDeclPopupClose = () => {
    setNomineeOptOutDeclPopupOpen(false)
  }

  const { onboardingType = '' } = application || {};

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, nomineeDetailsSchema(application?.applicants, currencyCode, company), true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues, dirty }) => {
        const nomineePercentage = values
          ?.nominees
          ?.filter((_nominee) => _nominee.isActive)
          ?.reduce((acc, curr) => acc = acc + Number(curr.nomineePercentage), 0)

        return (
          <Grid
            container
            // rowSpacing={1}
            // columnSpacing={5}
            columnSpacing={3}
            rowSpacing={0.5}
            // sx={{
            //   width: '100%',
            //   ml: 0,
            //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            // }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Grid item xs={12}>
              <Notes displayContent={`Investor(s) have the option to choose upto three nominees.${isOnboardingTypeMinor(onboardingType) ? ' Note:- Guardian will be the nominee' : ''}`} />
            </Grid>
            <Grid item xs={12} my={2}>
              <Box sx={{ width: "fit-content" }}>
                <MFCheckbox
                  disabled={isOnboardingTypeMinor(onboardingType)}
                  name="doNotWishToNominate"
                  label="I do not wish to nominate."
                  sx={{ letterSpacing: '1px' }}
                  onChange={({ target: { checked } }) => {
                    const updatedNominees = !checked
                      ? [
                        ...values.nominees,
                        { ...newNominee, nomineePercentage: 100, sno: values.nominees.length },
                      ]
                      : values.nominees;
                    setValues({
                      ...nomineesData,
                      doNotWishToNominate:
                        values.nominees?.filter((item) => item.isActive).length === 0
                          ? checked
                          : !checked,
                      nominees: updatedNominees.map((nominee) => ({
                        ...nominee,
                      })),
                      nomineesSOA: values.nomineesSOA
                    });
                    checked && setBulkNomineeDelete(true);
                  }}
                  checked={values.doNotWishToNominate}
                />
                <Button
                  sx={(theme: Theme) => ({
                    ...theme.typography.subtitle_500,
                    color: theme.palette.primary[500],
                    textDecoration: "underline",
                    padding: "4px 3px",
                    "&:hover": {
                      textDecoration: "underline",
                    }
                  })}
                  onClick={handleNomineeOptOutDeclPopupOpen}
                >
                  Nominee opt out declaration
                </Button>
              </Box>
            </Grid>
            {values.nominees
              .filter((_nominee) => _nominee.isActive)
              .map((nominee, index) => {
                const nomineeTitle = getApplicantName(index + 1, true);
                return (
                  <React.Fragment key={index}>
                    <Grid item xs={12}>
                      <SubHeading
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          flexWrap: 'wrap',
                        }}>
                        <Typography variant='h3' color="text.primary"  sx={(theme: Theme) => ({
                          ...theme.typography.body_500
                        })}>
                          {nomineeTitle} Nominee Details
                        </Typography>
                        {/* <Box
                        sx={{ display: 'flex', alignItems: 'center' }}
                        onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}>
                        <Typography
                          sx={{
                            color: 'rgba(196, 42, 51, 0.8)',
                            fontSize: 12,
                            ml: 'auto',
                            letterSpacing: '-0.2px',
                            cursor: 'pointer',
                          }}>
                          Remove Nominee{' '}
                        </Typography>
                        <IconButton sx={{ p: '2px' }}>
                          <CardMedia
                            component="img"
                            src="/images/delete-red.svg"
                            alt="Delete Icon"
                            sx={{ width: 'unset' }}
                          />
                        </IconButton>
                      </Box> */}
                        <IconButton
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "primary.100",
                            borderRadius: "50%",
                            padding: "5px",
                            cursor: "pointer"
                          }}
                          onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}
                          aria-label={`Delete ${nomineeTitle} Nominee`}
                        >
                          <DeleteIconFilled />
                        </IconButton>
                      </SubHeading>
                    </Grid>
                    <Nominee
                      nomineeName={index + 1}
                      index={nominee.sno as number}
                      key={nominee.sno as number}
                      mdmsCountriesList={mdmsCountriesList}
                      nomineeTitle={nomineeTitle}
                      values={values}
                    />
                    <Grid item xs={12} my={1} />
                  </React.Fragment>
                );
              })}
            {values.nominees.filter((item) => item.isActive).length < 3 && (
              <Grid item xs={12}>
                <Button
                  // variant="contained"
                  variant='outlined'
                  startIcon={<AddIcon sx={{
                    color: (isOnboardingTypeMinor(onboardingType) || (nomineePercentage >= 100)) ? 'grey.400' : 'primary.500'
                  }} />}
                  sx={(theme: Theme) => ({
                    // color: 'common.white',
                    // fontWeight: 500,
                    // fontSize: 14,
                    // mt: 2,
                    // mx: 1,
                    backgroundColor: `${theme.palette.primary[500]}1A`,
                    border: `1px solid ${theme.palette.primary[500]}`,
                    ...theme.typography.body_500,
                    color: theme.palette.primary[500],
                    padding: "10px 15px",
                    '&.Mui-disabled': {
                      backgroundColor: theme.palette.textDark.disabled,
                      color: theme.palette.grey[400]
                    }
                  })}
                  disabled={isOnboardingTypeMinor(onboardingType) || (nomineePercentage >= 100)}
                  onClick={() =>
                    setValues({
                      ...values,
                      nominees: [
                        ...values.nominees,
                        {
                          ...newNominee,
                          nomineePercentage: values.nominees.filter((item) => item.isActive).length
                            ? 0
                            : 100,
                          sno: values.nominees.length,
                        },
                      ],
                      doNotWishToNominate: false,
                    })
                  }>
                  Add Nominee
                </Button>
              </Grid>
            )}
            {!values.doNotWishToNominate && <Grid item xs={12} mt={2}>
              <MFCheckbox
                name="nomineesSOA"
                label="Display Nominees in SOA"
                checked={values.nomineesSOA}
              />
            </Grid>}
            <Grid item xs={12} my={2} />
            {isDirect ? (
              <Grid item xs={12}
                sx={(theme: Theme) => ({
                  [theme.breakpoints.down('sm')]: {
                    mt: "-14px"
                  }
                })}>
                <MFSubmitButton
                  fullWidth
                  label="Submit to BSE"
                  loadingEnable={loading}
                  disabled={!dirty}
                />
              </Grid>

            ) : (
              <ProceedSaveLater
                saveLater={() => {
                  setValues({
                    ...values,
                    nominees: values.nominees.map((nominee) => ({
                      ...nominee,
                      nomineeRelationship:
                        nominee.Relationship === 'OTHERS'
                          ? nominee.nomineeRelationship
                          : nominee.Relationship,
                    })),
                    saveType: 'save for later',
                  });
                }}
                saveAndProceed={() => {
                  setValues({
                    ...values,
                    nominees: values.nominees.map((nominee) => ({
                      ...nominee,
                      nomineeRelationship:
                        nominee?.Relationship === 'OTHERS'
                          ? nominee.nomineeRelationship
                          : nominee?.Relationship,
                    })),
                    saveType: 'save and proceed',
                  });
                }}
                loader={loading}
                clickedButton={values.saveType}
                saveButtonText="Continue"
                showEndIcon={false}
              />
            )}
            <ConfirmationDialog
              showIcon
              // message={'Are you sure you want to delete nominee(s) ?'}
              message="Deleting nominee details"
              subMessage="Are you sure you want to delete the nominee details? "
              open={nomineeToDelete !== null || bulkNomineeDelete !== false}
              setOpen={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
              onSave={async () => {
                try {
                  const { id } = application || {};
                  const remainedApplicants = values.nominees.map((nominee, i) => {
                    if (nominee.sno === nomineeToDelete?.index || bulkNomineeDelete) {
                      return {
                        ...nominee,
                        isActive: false,
                      };
                    }
                    return nominee;
                  });
                  setValues({
                    ...values,
                    nominees: remainedApplicants,
                    doNotWishToNominate:
                      remainedApplicants.filter((item) => item.isActive).length === 0
                        ? true
                        : values.doNotWishToNominate,
                    nomineesSOA: remainedApplicants.filter((item) => item.isActive).length === 0 ? false : values.nomineesSOA
                  });
                  setBulkNomineeDelete(false);
                  setNomineeToDelete(null);
                } catch (e) {
                  console.error((e as Error).message);
                }
              }}
              onCancel={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
            />
            <NomineeOptOutDeclPopup
              open={nomineeOptOutDeclPopupOpen}
              onClose={handleNomineeOptOutDeclPopupClose}
            />
          </Grid>
        )
      }}
    </Formik>
  );
}
